// removed by extract-text-webpack-plugin
module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","brand":"_u4avc-WstuZP5sdbqIV1","coffee":"_2eg0W-8axvya7mllmiwgMI","card":"_3Gs6urcu8I7zr2hVYLFsz7","claim":"AqIwscDYxW5j-eg6aYiSD","footer":"_1OoeUTZJCBvaQH3ZXP33Bt","divider":"_11PYTor6dha42yTLwawq8T","fb":"_2mddsr5vX5o9EgTtFFEW5S"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 875
// module chunks = 0